<template>
  <div>
    <div>
      <img
        class="w-100"
        src="@/assets/Retro3.jpg"
        alt="tbd"
      >

      <div
        class="flex-grow-1 text-center p-4"
      >
        <div>
          <h4>
            Sarah Werther - New Work Guide & Culture Coach
          </h4>
          <div class="pt-2">
            <h6>
              <a
                href="javascript:void(0)"
                @click="$emit('scrollTo', getTabIndex('leistungen'))"
              >
                Leistungen</a>
              <h6 />
            </h6>
          </div>


          <div>
            <h6>
              <a
                href="javascript:void(0)"
                @click="$emit('scrollTo', getTabIndex('herangehensweise'))"
              >
                Herangehensweise</a>
            </h6>
          </div>

          <div>
            <h6>
              <a
                href="javascript:void(0)"
                @click="$emit('scrollTo', getTabIndex('sarah'))"
              >Über mich</a>
            </h6>
          </div>

          <div>
            <h6>
              <a
                href="javascript:void(0)"
                @click="$emit('scrollTo', getTabIndex('contact'))"
              >
                Kontakt</a>
            </h6>
          </div>
        </div>
        <div class="pt-4">
          <img
            class="logo"
            src="@/assets/LogoAuftrag2.png"
            alt="Logo"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tabs from '@/data/tabs';


export default {

  data() {
    return {
      tabs,
    };
  },
  methods: {
    getTabIndex(componentName) {
      return tabs.findIndex((t) => t.componentName === componentName || t.title === componentName);
    },
  },
};
</script>

<style lang="scss" scoped>/*
.image-blurred-edge {
  background-image: url('~@/assets/Sarah_Hochformat2.jpg');
  width: 220px;
  height: 300px;
  // you need to match the shadow color to your background or image border for the desired eff.
  box-shadow: 0 0 8px 8px map-get($theme-colors, primary) inset;
}**/

</style>

<style scoped>

.logo{

  width: 12em;
}
.submenu a + a::before {
  content: '■';
  font-size: 0.4em;
  margin-left:0.45em;
  margin-right: 0.45em;
  vertical-align: 0.4em;

}
</style>
